module.exports = "<div class=\"footer text-align-center\" [innerHTML]=\"link\">\n  {{ label }}\n</div>"